/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fork, takeLatest } from 'redux-saga/effects';
import ActionConstants from '../constants/';
import workerSaga from './workerSaga';
import { takeLatestUntilApiCancel } from './merchantListing';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* signupWatcher(): Generator<any, void, unknown> {
  yield takeLatest(ActionConstants.GET_TODAY_TRANSACTIONS_DATA, workerSaga);
  yield takeLatest(ActionConstants.GET_OVERVIEW_DATA, workerSaga);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_EDGE_TODAY_TRANSACTIONS_DATA
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_EDGE_OVERVIEW_DATA
  );
  yield takeLatest(ActionConstants.GET_BETA_TOGGLE, workerSaga);
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_MODE_BREAKDOWN_ACTION
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_CHECKOUT_INSIGHTS_PAYMENT_PERFORMANCE_ACTION
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_CHECKOUT_INSIGHTS_OFFER_EFFECTIVENESS_ACTION
  );
  yield fork(
    takeLatestUntilApiCancel,
    ActionConstants.GET_CHECKOUT_INSIGHTS_CONVERSION_FUNNEL_ACTION
  );
}
